import React from "react";
import { Treebeard, decorators } from "react-treebeard";
import defaultTheme from "./treebeard/themes/default";
import { api } from '../../services/rest';
import { isNullOrUndefined } from 'util';
import { withRouter } from 'react-router-dom';
import { Div } from './treebeard/components/common';
import * as filters from './treebeard/filter';
import { includes } from 'lodash';
import Header from './treebeard/Header';

class TreeView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: "",
            active: "",
            src: "",
            url: this.props.value ? this.props.value : "",
            fileList: [],
            unfilteredList: []
        };
        this.getFileOptions = this.getFileOptions.bind(this);
        this.onFilterMouseUp = this.onFilterMouseUp.bind(this);
        this.onClick = this.onClick.bind(this);
        this.selectChildNode = this.selectChildNode.bind(this);
    }

    componentDidMount() {
        if (this.props.value) {
            api
                .get(`/${this.props.match.params.client}/${this.props.match.params.project}/Resources/${this.state.url.replace(/\/+/g, '---')}`)
                .then(response => this.setState({ src: response.data.src }));
        };
        this.getFileOptions();
    }

    async getFileOptions() {

        fetch(`/api/${this.props.match.params.client}/${this.props.match.params.project}/NewFileList/`)
            .then(response => {
                return response.json();
            }).then(data => this.setState({
                fileList: data,
                unfilteredList: data
            }));
        if (!this.state.url.includes('/resources/')) {
            var url = this.state.url;
            if (url.substring(0, 1) === '/') {
                url = url.substring(1);
            }
            this.setState({ url: '/resources/' + url })
        }
    }

    onFilterMouseUp({ target: { value } }) {
        const filter = value.trim();
        if (!filter) {
            return this.setState(() => ({ fileList: this.state.unfilteredList }));
        }
        let filtered = filters.filterTree(this.state.fileList, filter);
        filtered = filters.expandFilteredNodes(filtered, filter);
        this.setState(() => ({ fileList: filtered }));
    }

    selectChildNode(nodes, itemToFind) {
        nodes.children.forEach((node) => {
            if (!isNullOrUndefined(node.fullPath)) {
                if ('/' + node.fullPath.replace(/\\+/g, '/') === itemToFind) {
                    node.active = true;
                    node.toggled = true;
                } else {
                    if (!isNullOrUndefined(node.children)) {
                        this.selectChildNode(node, itemToFind)
                    }
                }
            } else {
                if (!isNullOrUndefined(node.children)) {
                    this.selectChildNode(node, itemToFind)
                }
            }
        });
    }

    onClick(node) {
        console.log("selected a node: " + node);
        const { cursor, fileList } = this.state;

        if (cursor) {
            this.setState(() => ({ cursor, active: false }));
            if (!includes(cursor.children, node)) {
                cursor.toggled = false;
                cursor.active = false;
            }
        }

        node.active = true;

        this.setState(() => ({ cursor: node, fileList: Object.assign({}, fileList) }));

        if (!isNullOrUndefined(node.fullPath)) {
            this.setState(() => ({ src: node.fullPath , url: node.fullPath}));
        }
    }

    render() {
        decorators.Header = Header;
        decorators.onClick = this.onClick
        defaultTheme.tree.base = {
            ...defaultTheme.tree.base,
            color: "white",
            backgroundColor: "#1D1D1D"
        };       
        if (this.state.url !== "" && this.state.fileList.length !== 0 ) {
            var fileList = this.state.fileList;
            this.selectChildNode(fileList, this.state.url);
            if (this.state.fileList !== fileList) {
                this.setState({ fileList: fileList });
            }
        }
        return (
            <div className="imageWidget" >
                <div>
                    <Div className="searchBox">
                        <Div className="input-group">
                            <span className="input-group-addon">
                                <i className="glyphicon glyphicon-search" />
                            </span>
                            <input
                                className="form-control"
                                onKeyUp={this.onFilterMouseUp.bind(this)}
                                placeholder="Search the tree..."
                                type="text"
                            />
                        </Div>
                    </Div>
                </div>
                <div className="treeImg">
                    <div className="tree">
                        <Treebeard
                            className="tree"
                            style={defaultTheme}
                            data={this.state.fileList}
                            decorators={decorators}
                            onToggle={(node, toggled) => {
                                const { cursor, fileList } = this.state;
                                if (cursor) {
                                    cursor.active = !cursor.active;
                                    this.setState(() => ({ cursor, active: false }));
                                }
                                node.active = !node.active;
                                if (node.children) {
                                    node.toggled = toggled;
                                } else {
                                    this.setState({ url: '/' + node.fullPath.replace(/\\+/g, '/') });
                                    api
                                        .get(`/${this.props.match.params.client}/${this.props.match.params.project}/Resources/${node.fullPath.replace('resources\\','').replace(/\\+/g, '---')}`)
                                        .then(response => { this.props.onChange('/' + node.fullPath.replace(/\\+/g, '/')); this.setState({ src: response.data.src }) });
                                }
                                this.setState(() => ({ cursor: node, fileList: Object.assign({}, fileList) }));

                            }}
                        />
                    </div>
                    <div className="imageThumb">
                        <img src={this.state.src} alt={this.state.src} />
                    </div>
                </div>
                <div className="imageWarn">
                    Please note that images above may appear cropped but they will be unaltered when viewed on the site.
                </div>
            </div>
        );
    }
}

const ImgWidget = withRouter(TreeView);

function NewImageWidget(props) {
    return (
        <ImgWidget {...props} />
    );
}

export default NewImageWidget;
